function dispatchDOMEvent(
  DOMElement: HTMLElement,
  EventType: string,
  options: { [key: string]: string | boolean } = {
    bubbles: true,
  }
) {
  const changeEvent = new Event(EventType, options);
  DOMElement.dispatchEvent(changeEvent);
}

export default dispatchDOMEvent;
